<template>
    <div class="tip-time-word pr-4 text-theme-black-850 box-border text-sm" :style="{width: showWidth+'px'}">
      <p class="mb-3">地区数据源和时间数据源的数据有关联关系时，地区筛选才有意义。例如：</p>
      <p class="font-medium mb-2">地区数据源</p>
      <table :class="[showWidth == 494 ? '' : 'ml-4']" border="1" Cellspacing="0" Cellpadding="0">
          <tr>
            <td>数据ID</td>
            <td>所属地区</td>
          </tr>
          <tr>
            <td>1</td>
            <td>北京</td>
          </tr>
          <tr>
            <td>2</td>
            <td>北京</td>
          </tr>
          <tr>
            <td>3</td>
            <td>上海</td>
          </tr>
      </table>
      <p class="mt-3 mb-2">时间数据源</p>
      <table :class="[showWidth == 494 ? '' : 'ml-4']" border="1" Cellspacing="0" Cellpadding="0">
        <tr>
          <td>数据ID</td>
          <td>2020年业绩（元）</td>
        </tr>
        <tr>
          <td>1</td>
          <td>1000.00</td>
        </tr>
        <tr>
          <td>2</td>
          <td>1500.00</td>
        </tr>
        <tr>
          <td>3</td>
          <td>2000.00</td>
        </tr>
      </table>
      <p class="mt-3 mb-2">地区数据源和时间数据源通过 【数据ID】进行关联，此时我们筛选出各地区的 2020年业绩情况</p>
      <table :class="[showWidth == 494 ? '' : 'ml-4']" border="1" Cellspacing="0" Cellpadding="0">
        <tr>
          <td>数据ID</td>
          <td>所属地区</td>
        </tr>
        <tr>
          <td>北京</td>
          <td>2500.00</td>
        </tr>
        <tr>
          <td>上海</td>
          <td>2000.00</td>
        </tr>
      </table>
    </div>
</template>

<script>
export default {
  name: 'TimeSettingTip',
  props: {
    showWidth: {
      type: Number,
      default: 494
    }
  },
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.tip-time-word{
  z-index: 9999;
  line-height: 22px;
  font-size: 12px;
  p{
    font-size: 14px;
  }
}
td {
  border: 1px solid #e7e9eb;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  width: 129px;
  height: 32px;
  background-color: #fff;
  text-align: center;
}
table tr:nth-child(1) td{
  background-color: #f5f5f5;
}
</style>